// extracted by mini-css-extract-plugin
module.exports = {"emneknagg":"dhsgEN6no-emneknagg"};